module.exports = __webpack_public_path__ + "img/add-player-white.696a0b4a.svg";